import { css } from '@emotion/core';

export default ({ isFixed }) => ({
  footerStyles: ({ classes, cybs }) => css`
    background-color: ${cybs?.base?.cybs?.lightGray ?? '#f4f4f4'};
    border-bottom-left-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
    border: 1px solid ${cybs?.base?.wcag21?.stoneGrey ?? '#62798D'};
    box-shadow: 0 0 1px rgba(42, 46, 105, 0.1);
    ${classes?.structure?.padding?.space?.left[1] ?? 'padding-left: 0.5rem;'}
    ${classes?.structure?.padding?.space?.right[1] ??
    'padding-right: 0.5rem;'}
    ${classes?.structure?.padding?.space
      ?.bottom[1] ?? 'padding-bottom: 0.5rem;'}

    ${isFixed
      ? `
        position: sticky; 
        bottom: 0;
        width: 100%;
        margin-top: 1.25rem;
      `
      : ''}
    min-height: 3.5rem;
    min-width: 100%;
    width: fit-content;
    width: 100%;

    button {
      margin-bottom: 0px !important;
    }
  `,
  wrapperStyles: css`
    flex-wrap: wrap;
    height: 100%;
  `,
  leftBtnGroupStyles: css`
    margin-top: 0.5rem;
    margin-right: 0.5rem;
    
    @media (max-width: 320px) {
      margin-right: 0rem;
    }
  `,
  rightBtnGroupStyles: css`
    margin-top: 0.5rem;
  `
});
